import React from "react";
import { useTheme } from "styled-components";

export default function ErrorModal({ open, title = "Insufficient credits", message = "You do not have enough credits to perform this action.", primaryAction, onClose, cancelLabel = "Close" }) {
  const theme = useTheme();
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="rounded-lg shadow-lg w-[90%] max-w-md p-6 bg-card text-card-foreground"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-2 text-lg font-semibold">{title}</div>
        <div className="mb-6 text-sm text-muted-foreground">{message}</div>
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded border border-border text-foreground hover:bg-accent transition-colors"
          >
            {cancelLabel}
          </button>
          {primaryAction && (
            <button
              onClick={primaryAction.onClick}
              className="px-4 py-2 rounded transition-opacity hover:opacity-90"
              style={{ backgroundColor: theme.colors.primary, color: theme.colors.buttonTextOnPrimary }}
            >
              {primaryAction.label}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}


